<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import CheckIconListItem from '../partials/CheckIconListItem.vue';
import LandingFeatureItem from '../partials/LandingFeatureItem.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import LandingContactSection from '../../Landing/LandingContactSection.vue';
import MetricHighlight from './partials/MetricHighlight.vue';
import AppCard from '../../../Shared/AppCard.vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        AppCard,
        MetricHighlight,
        LandingContactSection,
        SmartBreadcrumbs,
        LandingFeatureItem,
        CheckIconListItem,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <div class="bg-gray-100">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('landing.user_roles'),
                        href: meta.links.landing,
                    },
                    {
                        name: $tc('messages.teachers', 2),

                        href: meta.links.teachers,
                    },

                    {
                        name: $t('messages.turing'),
                        href: null,
                    },
                ]"
            />
        </div>
    </div>

    <div class="flex justify-center mt-5">
        <div class="flex items-center gap-4">
            <div>
                <img src="/img/new_landing/t_math.png" class="h-10 w-10 object-contain" alt="" />
            </div>
            <div><h1 class="text-6xl" v-html="$t('landing.turing.section01.title')" /></div>
        </div>
    </div>

    <div class="lg:mx-auto lg:max-w-4xl lg:px-8 mt-5">
        <div>
            <p class="text-2xl" v-html="$t('landing.turing.section01.subtitle')" />
        </div>
    </div>

    <div class="lg:mx-auto lg:max-w-4xl lg:px-8 mt-5">
        <div class="sm:flex items-center gap-4">
            <div class="shrink-0">
                <img src="/img/new_landing/student.png" class="h-48 w-48 object-contain" alt="" />
            </div>
            <div class="text-lg">
                <ul>
                    <li>
                        <CheckIconListItem> {{ $t('landing.turing.section01.group1_item1') }}</CheckIconListItem>
                    </li>
                    <li>
                        <CheckIconListItem> {{ $t('landing.turing.section01.group1_item2') }}</CheckIconListItem>
                    </li>
                    <li>
                        <CheckIconListItem> {{ $t('landing.turing.section01.group1_item3') }}</CheckIconListItem>
                    </li>
                    <li>
                        <CheckIconListItem> {{ $t('landing.turing.section01.group1_item4') }}</CheckIconListItem>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sm:flex items-center gap-4 m-5 flex-row-reverse">
            <div class="shrink-0">
                <img src="/img/new_landing/teacher.png" class="h-48 w-48 object-contain" alt="" />
            </div>
            <div class="text-lg">
                <div>
                    <CheckIconListItem align-right>
                        {{ $t('landing.turing.section01.group2_item1') }}</CheckIconListItem
                    >
                </div>
                <div>
                    <CheckIconListItem align-right>
                        {{ $t('landing.turing.section01.group2_item2') }}</CheckIconListItem
                    >
                </div>
                <div>
                    <CheckIconListItem align-right>
                        {{ $t('landing.turing.section01.group2_item3') }}</CheckIconListItem
                    >
                </div>
                <div>
                    <CheckIconListItem align-right>
                        {{ $t('landing.turing.section01.group2_item4') }}</CheckIconListItem
                    >
                </div>
            </div>
        </div>
    </div>

    <div class="bg-gray-100 mt-5">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-5">
            <span class="font-semibold text-2xl">{{ $t('landing.turing.section02.title') }}</span>
        </div>
    </div>

    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <span>{{ $t('landing.turing.section02.subtitle') }}</span>
        </div>
    </div>
    <div class="mx-auto max-w-2xl lg:max-w-4xl">
        <div class="mt-5 lg:mt-12 grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item1_title')"
                :description="$t('landing.turing.section02.item1_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item2_title')"
                :description="$t('landing.turing.section02.item2_description')"
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item3_title')"
                :description="$t('landing.turing.section02.item3_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item4_title')"
                :description="$t('landing.turing.section02.item4_description')"
            />
        </div>
    </div>

    <div class="mt-5">
        <img src="/img/landing/screenshots/turing_tags.jpg" class="mx-auto" alt="" />
    </div>
    <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
        <div class="mt-5 grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item5_title')"
                :description="$t('landing.turing.section02.item5_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item6_title')"
                :description="$t('landing.turing.section02.item6_description')"
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item7_title')"
                :description="$t('landing.turing.section02.item7_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item8_title')"
                :description="$t('landing.turing.section02.item8_description')"
            />
        </div>
    </div>

    <div class="bg-gray-100 mt-5">
        <div class="py-2">&nbsp;</div>
    </div>

    <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
        <div class="mt-5 grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item9_title')"
                :description="$t('landing.turing.section02.item9_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item10_title')"
                :description="$t('landing.turing.section02.item10_description')"
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item11_title')"
                :description="$t('landing.turing.section02.item11_description')"
                align-right
            />
            <LandingFeatureItem
                :title="$t('landing.turing.section02.item12_title')"
                :description="$t('landing.turing.section02.item12_description')"
            />
        </div>
    </div>

    <div class="bg-gray-100 mt-5">
        <div class="py-2">&nbsp;</div>
    </div>

    <div class="bg-gray-700 text-white">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 pb-12 pt-5">
            <div class="text-2xl py-8">
                <span class="font-bold">{{ $t('landing.turing.section03.title') }}</span>
            </div>

            <div class="mt-3">
                <iframe
                    class="mx-auto"
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/ODOsJF9MBXw?si=P85lCsbZePO52kc9"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="bg-gray-100">
        <div class="py-2">&nbsp;</div>
    </div>

    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <span class="font-semibold text-2xl">
                <span v-html="$t('landing.turing.section04.title')" />
            </span>
        </div>
    </div>

    <div class="mt-3">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <span class="text-xl" v-html="$t('landing.turing.section04.subtitle')" />
        </div>
    </div>

    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-5xl lg:px-8 py-2">
            <div>
                <MetricHighlight
                    class="mt-3"
                    :title-first="$t('landing.turing.section04.item01_title_first')"
                    :title-second="$t('landing.turing.section04.item01_title_second')"
                    :description="$t('landing.turing.section04.item01_description')"
                />
                <MetricHighlight
                    class="mt-3"
                    :title-first="$t('landing.turing.section04.item02_title_first')"
                    :title-second="$t('landing.turing.section04.item02_title_second')"
                    :description="$t('landing.turing.section04.item02_description')"
                />
                <MetricHighlight
                    class="mt-3"
                    :title-first="$t('landing.turing.section04.item03_title_first')"
                    :title-second="$t('landing.turing.section04.item03_title_second')"
                    :description="$t('landing.turing.section04.item03_description')"
                />
                <MetricHighlight
                    class="mt-3"
                    :title-first="$t('landing.turing.section04.item04_title_first')"
                    :title-second="$t('landing.turing.section04.item04_title_second')"
                    :description="$t('landing.turing.section04.item04_description')"
                />
            </div>
        </div>
    </div>

    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <div>
                <p class="text-xl whitespace-pre-line" v-html="$t('landing.turing.section04.description')"></p>
            </div>
        </div>
    </div>

    <div class="mt-5"></div>
    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-5xl lg:px-8 py-2">
            <div class="flex flex-col gap-4 divide-y-2 divide-gray-200">
                <AppCard color="light-gray">
                    <div class="p-4">
                        <div class="text-xl text-blue-500 font-semibold">
                            {{ $t('landing.turing.section05.item01_title') }}
                        </div>
                        <div class="mt-1 text-lg">
                            {{ $t('landing.turing.section05.item01_description') }}
                        </div>
                    </div>
                </AppCard>
                <div class="pt-4">
                    <AppCard color="light-gray">
                        <div class="p-4">
                            <div class="text-xl text-blue-500 font-semibold">
                                {{ $t('landing.turing.section05.item02_title') }}
                            </div>
                            <div class="mt-1 text-lg">
                                {{ $t('landing.turing.section05.item02_description') }}
                            </div>
                        </div>
                    </AppCard>
                </div>
                <div class="pt-4">
                    <AppCard color="light-gray">
                        <div class="p-4">
                            <div class="text-xl text-blue-500 font-semibold">
                                {{ $t('landing.turing.section05.item03_title') }}
                            </div>
                            <div class="mt-1 text-lg">
                                {{ $t('landing.turing.section05.item03_description') }}
                            </div>
                        </div>
                    </AppCard>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-5">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <div class="relative isolate overflow-hidden bg-gray-900 rounded-2xl">
                <div class="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                    <div class="mx-auto max-w-2xl text-center">
                        <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            {{ $t('messages.try_practice_quiz_free') }}
                        </h2>
                        <div class="mt-10 flex items-center justify-center gap-x-6">
                            <a
                                :href="meta.links.practice_index"
                                class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                                >{{ $t('messages.get_started') }}</a
                            >
                        </div>
                    </div>
                </div>
                <svg
                    viewBox="0 0 1024 1024"
                    class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
                    aria-hidden="true"
                >
                    <circle
                        cx="512"
                        cy="512"
                        r="512"
                        fill="url(#8d958450-c69f-4251-94bc-4e091a323369)"
                        fill-opacity="0.7"
                    />
                    <defs>
                        <radialGradient id="8d958450-c69f-4251-94bc-4e091a323369">
                            <stop stop-color="#7775D6" />
                            <stop offset="1" stop-color="#E935C1" />
                        </radialGradient>
                    </defs>
                </svg>
            </div>
        </div>
    </div>

    <!--    contact-->
    <LandingContactSection />
</template>
